import React, {
  useEffect,
  useState
} from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import SplashScreen from 'src/components/SplashScreen';
import { setUserData, logout } from 'src/actions/accountActions';
import authService from 'src/services/authService';
//import { useHistory } from 'react-router';

function Auth({ children }) {
  const dispatch = useDispatch();
  //const history = useHistory();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      authService.setAxiosInterceptors({
        onLogout: () => dispatch(logout())
      });
      authService.handleAuthentication();
      if (authService.isAuthenticated()) {
        const user = await authService.loginInWithToken();
        await dispatch(setUserData(user));
      }else{
        //El problema de redireccionar aca es que aquellas paginas fuera de la seguridad se van todas al login.
        //Pero si no tengo esto, me tira los children aunque no este autenticado. Se handlea desde los AuthGuard.js
        //history.push('/');
      }
      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any
};

export default Auth;
